import realpressMap from './single-property/map';
import realpressReview from './single-property/review';
import realpressGallerySlider from './single-property/gallery-slider';
import realpressMediaNavigation from './single-property/media-navigation';
import realpressContactForm from './single-property/contact-form';
import realpressFloorPlans from './single-property/floor-plans';
import realpressMortgageCalculator from './single-property/mortgage-calculator';
import realpressSimilarProperty from './single-property/similar-property';
import realpressWishList from './single-property/wishlist';
import realpressMortgageCalculatorWidget from './widgets/mortgage-calculator';

document.addEventListener('DOMContentLoaded', (event) => {
    realpressMap();
    realpressReview();
    realpressGallerySlider();
    realpressMediaNavigation();
    realpressContactForm();
    realpressFloorPlans();
    realpressMortgageCalculator();
    realpressMortgageCalculatorWidget();
    realpressWishList();
    realpressSimilarProperty();
});
